import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export interface UnsubscribedClient {
  id: number;
  firstname?: string;
  name?: string;
  email: string;
  createdAt?: Date | string;
  reference?: string;
  status?: string;
}

export interface UnsubscribedClientsResponse {
  clients?: UnsubscribedClient[];
  data?: UnsubscribedClient[];
}

export const checkEmail = async (email: string) => {
  try {
    const response = await axios.post(`${API_URL}/user/checkEmail`, { email });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw new Error(
        error.response?.data.message ||
        "Erreur lors de la vérification de l'email."
      );
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};
export const sendMail = async ( emailData: any ) => {
  try {
    emailData.sender = emailData.email;
    const response = await axios.post(`${API_URL}/email/custom`, emailData);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw new Error(
        error.response?.data.message || "Erreur lors de l'envoi de l'email."
      );
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};


export const sendMailSponsor = async (emailData: {
  name: string;
  email: string;
  object: string;
  sender: string;
  message: string;
  bcc: string[];
}) => {
  try {
    const response = await axios.post(`${API_URL}/email/sponsor`, emailData);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw new Error(
        error.response?.data.message || "Erreur lors de l'envoi de l'email de parrainage."
      );
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};

export const sendFormDataMail = async (emailData: FormData) => {
  try {
    const response = await axios.post(
      `${API_URL}/email/email-attachments`,
      emailData
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Détails de l'erreur:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
      
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          "Erreur lors de l'envoi de l'email.";
      
      throw new Error(errorMessage);
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};

export const sendAttestationByEmail = async (data: {
  email: string | undefined;
  attestationLegale: string | undefined;
}) => {
  try {
    if (!data.email || !data.attestationLegale) {
      throw new Error("L'email et le nom du fichier à envoyer est obligatoire");
    }
    const response = await axios.post(
      `${API_URL}/email/alo-attestation/send`,
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw new Error(
        error.response?.data.message || "Erreur lors de l'envoi de l'email."
      );
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};
export const sendAttestationAloByEmail = async (data: {
  email: string | undefined;
  attestationAlo: string | undefined;
}) => {
  try {
    if (!data.email || !data.attestationAlo) {
      throw new Error("L'email et le nom du fichier à envoyer est obligatoire");
    }
    const response = await axios.post(
      `${API_URL}/email/alo-attestation/send`,
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw new Error(
        error.response?.data.message || "Erreur lors de l'envoi de l'email."
      );
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};

export const sendJustifByEmail = async (data: {
  email: string | undefined;
  annonceId: number | undefined;
}) => {
  try {
    if (!data.email || !data.annonceId) {
      throw new Error("L'email et l'annonce à envoyer est obligatoire");
    }
    const response = await axios.post(
      `${API_URL}/email/justificatif/send`,
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw new Error(
        error.response?.data.message || "Erreur lors de l'envoi de l'email."
      );
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};

export const getEmailCountByCurrentMonth = async (data: {
  email: string | undefined;
}) => {
  try {
    if (!data.email || !data.email) {
      throw new Error("L'email est obligatoire");
    }
    const response = await axios.get(
      `${API_URL}/email/count/current-month/${data.email}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw new Error(
        error.response?.data.message || "Erreur lors de l'envoi de l'email."
      );
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};

export const checkTokenUnsubscription = async (data: { token: string }) => {
  try {
    if (!data.token) {
      throw new Error("Le token à vérifié est obligatoire");
    }
    const response = await axios.post(
      `${API_URL}/email/linkroute/check`, { linkToken: data.token }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw error.response?.data;
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
}

export const isSubscriber = async () => {
  try {
    const response = await axios.get(`${API_URL}/email/is-subscriber`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw error.response?.data;
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};

export const subscribe = async () => {
  try {
    const response = await axios.post(`${API_URL}/email/subscribe`, undefined, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw error.response?.data;
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};

export const unSubscribe = async (reason: string = "Désabonnement depuis le compte") => {
  try {
    const data = { reason }; 
    const response = await axios.post(`${API_URL}/email/unsubscribe`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw error.response?.data;
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};




export const getAllUnsubscribedClients = async (): Promise<UnsubscribedClientsResponse> => {
  try {
    const response = await axios.get(`${API_URL}/email/unsubscribes`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw new Error(error.response?.data.message || "Erreur lors de la récupération des clients désinscrits.");
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};

export const getClientEmailHistories = async (page: number = 1, limit: number = 20, search: string = ''): Promise<any> => {
  try {
    const response = await axios.get(
      `${API_URL}/email/email-histories/clients?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw new Error(error.response?.data?.message || "Erreur lors de la récupération des emails des clients.");
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};

export const getAdminEmailHistories = async (page: number = 1, limit: number = 20, search: string = ''): Promise<any> => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/email/email-histories/admin?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data; 
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw new Error(error.response?.data?.message || "Erreur lors de la récupération des emails de l'admin.");
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};

export const getMySentEmails = async (page: number = 1, limit: number = 20): Promise<any> => {
  try {
    const token = localStorage.getItem("token");

    if (!token) {
      throw new Error("Token d'authentification introuvable");
    }

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/email/email-histories/me?page=${page}&limit=${limit}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw new Error(error.response?.data?.message || "Erreur lors de la récupération des mails envoyés.");
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};


// Service simplifié
export const getUsersWithoutAnnonce = async (): Promise<any> => {
  try {
    const token = localStorage.getItem("token");
    
    if (!token) {
      throw new Error("Token d'authentification manquant");
    }
    
    const response = await axios.get(
      `${API_URL}/user/userwithoutannonce`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": token
        }
      }
    );
    
    return response.data.users || [];

  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Message d'erreur :", error.message);
      throw new Error(
        error.response?.data?.error || 
        "Erreur lors de la récupération des prospects."
      );
    } else {
      console.error("Erreur inattendue :", error);
      throw new Error("Erreur inattendue.");
    }
  }
};